import React from "react";
import "../../Style/Components/select-tab.scss";

export default function SelectTab({
  tabs = [],
  curtab = [],
  handlechange,
}) {
  const toggleTab = (value) => {
    if (curtab.includes(value)) {
      handlechange(curtab.filter((item) => item !== value));
    } else {
      handlechange([...curtab, value]);
    }
  };

  return (
    <div className="select-tab">
      <div className="select-tab__scroll" role="group" aria-label="Filter tabs">
        {tabs.map((tab) => {
          const { label, value } =
            typeof tab === "string"
              ? { label: tab, value: tab }
              : tab;

          const isActive = curtab.includes(value);

          return (
            <button
              key={value}
              type="button"
              aria-pressed={isActive}
              className={`select-tab__pill${
                isActive ? " select-tab__pill--active" : ""
              }`}
              onClick={() => toggleTab(value)}
            >
              {isActive && (
                <svg
                  className="select-tab__check"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M2.5 7.3L5.4 10.2L11.5 3.6"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}

              <span className="select-tab__label">{label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}